// import { computed } from 'vue';

// export function useItemDto(item) {
//     const id = computed(() => {
//         if (item && item.id && item.id.length > 0) {
//             return item.id;
//         }
//         return '';
//     });

//     const sourceType = computed(() => {
//         if (item && item.sourceType && item.sourceType.length > 0) {
//             return item.sourceType;
//         }
//         return '';
//     });

//     const primaryImageUrl = computed(() => {
//         let url = '/images/no-image.jpg';
//         if (item && item.images && item.images.length > 0) {
//             url = item.images[0].src ? item.images[0].src : item.images[0] ;

//         } else if (item && item.image && item.image != '') {

//             url = item.image;

//         } else if (item && item.attachments && item.attachments.length > 0) {
//             url = item.attachments[0].url ? item.attachments[0].url : item.attachments[0] ;
//         }

//         return url;
//     });

//     const primaryImages = computed(() => {
//         let url = ['/images/no-image.jpg'];
//         if (item && item.images && item.images.length > 0) {
//             if (item.images.length > 1) url = [item.images[0].url, item.images[1].url];
//             else url = [item.images[0].url];
//         } else if (item && item.attachments && item.attachments.length > 0) {
//             if (item.attachments.length > 1) url = [item.attachments[0].url, item.attachments[1].url];
//             else url = [item.attachments[0].url];
//         }

//         return url;
//     });

//     const title = computed(() => {
//         if (item && item.name) {
//             return item.name;
//         }
//         return '';
//     });

//     const model = computed(() => {
//         if (item && item.model) {
//             return item.model;
//         }
//         return '';
//     });

//     const price = computed(() => {
//         if (sourceType.value == 'bundle') {
//             if (item.skuDetails?.length) {
//                 return item.skuDetails.reduce((sum, sku) => sum + sku.salesPrice, 0);
//             }
//         }

//         if(item && item.minPrice) {

//             return item.minPrice + '';
//         } else if (item.skus && item.skus.length > 0) {
//             return item.skus[0].salesPrice + '';

//         } else if(item && item.price) {

//             return item.price;
//         } else if(item && item.fee) {

//             return item.fee + '';
//         } else if(item && item.minFee) {
//             return item.minFee;
//         }
//         return '';
//     });

//     const discountedSalesPrice = computed(() => {
//         if (item.skus && item.skus.length > 0) {
//             return item.skus[0].discountedSalesPrice + '';
//         } else if(item && item.discountedSalesPrice) {
//             return item.discountedSalesPrice;
//         } 
//         return 0;
//     });

//     const subscriptionPrice = computed(() => {
//         if (item && item.tags && item.tags.length > 0) {
//             if (item && item.length > 0) {
//                 if (item.tags[0] == 'FINISHED_GOODS')
//                     return item.subscribedPrice + '';
//             }
//             if (item.tags[0] == 'FINISHED_GOODS')
//                 return item.subscribedPrice + '';
//         }
//         return '';
//     });


//     return {
//         id,
//         sourceType,
//         primaryImageUrl,
//         primaryImages,
//         title,
//         model,
//         price,
//         discountedSalesPrice,
//         subscriptionPrice,
//     };
// }
import { computed } from 'vue';

export function useItemDto(item) {
  const id = computed(() => item?.id ?? '');

  const sourceType = computed(() => item?.sourceType ?? '');

  const primaryImageUrl = computed(() => {
    if (item?.images?.length > 0) {
      const img = item.images[0];
      return img.src || img.url || '/images/no-image.jpg';
    }
    if (item?.image) return item.image;
    if (item?.attachments?.length > 0) {
      const att = item.attachments[0];
      return att.url || att.src || '/images/no-image.jpg';
    }
    return '/images/no-image.jpg';
  });

  const primaryImages = computed(() => {
    if (item?.images?.length > 0) {
      return item.images.map(img => img.src || img.url).filter(Boolean);
    }
    if (item?.attachments?.length > 0) {
      return item.attachments.map(att => att.url || att.src).filter(Boolean);
    }
    return ['/images/no-image.jpg'];
  });

  const title = computed(() => item?.name ?? '');

  const model = computed(() => item?.model ?? '');

  const price = computed(() => {
    if (sourceType.value === 'bundle' && item?.skuDetails?.length) {
      return item.skuDetails.reduce((sum, sku) => sum + (sku.salesPrice || 0), 0);
    }
    if (item?.minPrice) return String(item.minPrice);
    if (item?.skus?.length > 0) return String(item.skus[0].salesPrice);
    if (item?.price) return String(item.price);
    if (item?.fee) return String(item.fee);
    if (item?.minFee) return String(item.minFee);
    if (item?.regular_price) return String(item.regular_price); // WooCommerce support
    return '';
  });

  const discountedSalesPrice = computed(() => {
    if (item?.skus?.length > 0) return String(item.skus[0].discountedSalesPrice ?? 0);
    if (item?.discountedSalesPrice) return String(item.discountedSalesPrice);
    if (item?.sale_price) return String(item.sale_price); // WooCommerce support
    return '0';
  });

  const subscriptionPrice = computed(() => {
    if (item?.tags?.length > 0 && item.tags[0] === 'FINISHED_GOODS') {
      return String(item.subscribedPrice ?? '');
    }
    return '';
  });

  return {
    id,
    sourceType,
    primaryImageUrl,
    primaryImages,
    title,
    model,
    price,
    discountedSalesPrice,
    subscriptionPrice,
  };
}
